'use client'

import { Credit } from '@/screens/Credit'

const ServicesCreditPageContent = () => {
	return <Credit />
}

export function ServicesCreditClient() {
	return <ServicesCreditPageContent />
}
